<page-headline
    [linkTitle]="'Performance'"
    [module]="'performance'"
    [moduleIcon]="'fa-heartbeat'"
    [moduleLink]="'performance'"
    [pageTitle]="'Actuals vs Projections'"
>
</page-headline>
<div class="row-layout-track-left-align">
    <div class="branch-ddl">
        <angular2-multiselect
            [data]="branchesOfInterest"
            [(ngModel)]="selectedIdentifier"
            [settings]="branchListSettings"
            (onSelect)="onBranchChange($event)"
        >
        </angular2-multiselect>
    </div>
    <div class="year-ddl">
        <angular2-multiselect
            [data]="yearsOfInterest"
            [(ngModel)]="selectedYear"
            [settings]="yearListSettings"
            (onSelect)="onYearChange($event)"
            style="margin-left: 24px; position: relative; top: -19.5px"
        >
        </angular2-multiselect>
    </div>
    <div class="lo-ddl">
        <angular2-multiselect
            [data]="employeeList"
            [(ngModel)]="selectedEmployee"
            [settings]="employeeListSettings"
            (onSelect)="onEmployeeChange($event)"
        >
        </angular2-multiselect>
    </div>
</div>
<div class="projections-actuals-large-card-container">
    <div class="projections-actuals-large-card" *ngFor="let mainChart of mainCharts">
        <large-card [largeCardInteriorOptions]="mainChart.largeCardInteriorOptions"></large-card>
    </div>
</div>

<app-performance-actuals-vs-projections-table
    *ngIf="tableSummaryData"
    [data]="tableSummaryData"
></app-performance-actuals-vs-projections-table>
